import ChannelAction from '../../prat_actions/gt/channelAction'

const GtChannelReducers = (state = {isChannelLoading: true  }, action ) => {
    switch (action.type) {
        case ChannelAction.MASTER_CHANNEL_REQUEST :
            return {
                ...state,
                isChannelLoading:false,
            };

        case ChannelAction.MASTER_CHANNEL_SUCCESS :
            return {
                ...state,
                isChannelLoading:false,
                masterChannel: action.data
            };

        case ChannelAction.MASTER_CHANNEL_FAILED :
            return {
                ...state,
                isChannelLoading:false,
                error:action.error
            };

        // CHANNEL

        case ChannelAction.CHANNEL_REQUEST :
            return {
                ...state,
                isChannelLoading:false,
            };

        case ChannelAction.CHANNEL_SUCCESS :
            return {
                ...state,
                isChannelLoading:false,
                channel: action.data
            };

        case ChannelAction.CHANNEL_FAILED :
            return {
                ...state,
                isChannelLoading:false,
                error:action.error
            };

             // ELEMENt

        case ChannelAction.ELEMENT_REQUEST :
            return {
                ...state,
                isChannelLoading:false,
            };

        case ChannelAction.ELEMENT_SUCCESS :
            return {
                ...state,
                isChannelLoading:false,
                element: action.data
            };

        case ChannelAction.ELEMENT_FAILED :
            return {
                ...state,
                isChannelLoading:false,
                error:action.error
            };

             // SUB ELEMENT

        case ChannelAction.SUB_ELEMENT_REQUEST :
            return {
                ...state,
                isChannelLoading:false,
            };

        case ChannelAction.SUB_ELEMENT_SUCCESS :
            return {
                ...state,
                isChannelLoading:false,
                subElement: action.data
            };

        case ChannelAction.SUB_ELEMENT_FAILED :
            return {
                ...state,
                isChannelLoading:false,
                error:action.error
            };

        default :
          return {
              ...state
          };
    }
}

export default GtChannelReducers;